window.addEventListener('load', () => {
    let switcher = document.querySelector('.oc_mobile_category_switcher');
    if(switcher){
        switcher.addEventListener('change', (event) => {
            window.location.href = switcher.options[switcher.selectedIndex].value;
        })
    }
})